import { render, staticRenderFns } from "./history.vue?vue&type=template&id=8d463afc&scoped=true&lang=pug&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d463afc",
  null
  
)

export default component.exports